import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { CircularProgress } from "material-ui/Progress";

import {
  auth0Login,
  handleAuthenticationAuth0,
  isAuthenticatedAuth0
} from '../actions';


class AuthCallback extends Component {

  async componentDidMount() {
    const { history } = this.props;
    try {
      let response = await fetch( `${process.env.REACT_APP_API_URL}/auth/users/profile`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json; charset=utf-8"
          } 
        }
      );
      if (!response.ok) throw Error(response.statusText);
      
      let data = await response.json();
      this.props.handleAuthenticationAuth0(history, data);
    } catch (error) {
      if (error) {
        console.log(error);
        console.log("Error when try to get user data in fetch profile");
        this.props.history.push('/');
      }
    }
  }

  render() {
    return (
    <div 
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh"
    }}>
      <CircularProgress size={72} />
    </div>
    );
  }
}

const mapStateToProps = ({loginReducer, router}) => {
  const { user, loading, isAuthenticated, loadingCheck } = loginReducer;
  const { location } = router;
  return { user, loading, isAuthenticated, loadingCheck, location };
}

const mapDispatchToProps = {
  auth0Login,
  handleAuthenticationAuth0,
  isAuthenticatedAuth0
}

export default withRouter(
  connect(
    mapStateToProps, 
    mapDispatchToProps
  )(AuthCallback)
);



// WEBPACK FOOTER //
// ./src/components/AuthCallback.js